import { useState } from "react";

export default function useAttendanceListSwipe({ setTargetGroup, targetGroup }) {
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [touchStartY, setTouchStartY] = useState(null);
    const [touchEndY, setTouchEndY] = useState(null);
    const minSwipeDistance = 120; // Increased to prevent accidental swipes while scrolling
    const maxVerticalDistance = 40; // Decreased to ensure horizontal intent

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchEndY(null);
        setTouchStart(e.targetTouches[0].clientX);
        setTouchStartY(e.targetTouches[0].clientY);
    };

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
        setTouchEndY(e.targetTouches[0].clientY);
    };

    const onListSwipeEnd = () => {
        if (touchStart == null || touchEnd == null || touchStartY == null || touchEndY == null) return;
        const distance = touchStart - touchEnd;
        const verticalDistance = Math.abs(touchStartY - touchEndY);
        const isHorizontalIntent = Math.abs(distance) > minSwipeDistance && verticalDistance < maxVerticalDistance;
        if (!isHorizontalIntent) return;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;

        if (isLeftSwipe && targetGroup === "students" && setTargetGroup) {
            setTargetGroup("teachers");
        } else if (isRightSwipe && targetGroup === "teachers" && setTargetGroup) {
            setTargetGroup("students");
        }
    };

    return {
        onListSwipeEnd,
        onTouchMove,
        onTouchStart,
    };
}
